import { michiganKickerSharedAssetPreloader } from '../shared/asset-preloader'

export enum MI_MULTIPLIER_PUTTING_ASSETS {
  BACKGROUND1 = 'background1.png',
  BACKGROUND2 = 'green.png',
  BALL_ANIMATION = 'MI_PUTTING_BALL_ANIMATION',
  BLADE = 'blade.png',
  DOORWAY = 'doorway.png',
  FLAG_PREFIX = 'flag-',
  FLAG_WIN_PREFIX = 'flag-win-',
  FLAGPOLE = 'flagpole.png',
  GREEN_END = 'green-end.png',
  HOLE = 'hole.png',
  HOLE_MASK = 'hole-mask.png',
  PUTTER = 'putter.png',
  WINDMILL = 'windmill.png',
}

export enum MI_MULTIPLIER_PUTTING_TEXTURE_KEYS {
  ATLAS = 'MI_PUTTING_ATLAS',
  GOLF_BALL = 'MI_PUTTING_GOLF_BALL',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/putting/`

  michiganKickerSharedAssetPreloader(scene)

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_PUTTING_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      MI_MULTIPLIER_PUTTING_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/multiplier-putting-images.json`,
      `${prefix}atlas/`,
    )
  }

  scene.load.spritesheet(
    MI_MULTIPLIER_PUTTING_TEXTURE_KEYS.GOLF_BALL,
    `${prefix}multiplier-putting-ball-animation.png`,
    {
      frameWidth: 154,
      frameHeight: 162,
    },
  )
}
